
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { BusinessUserEditResolver, CompanyNameFastResolver } from './../businesses/services/business.resolver.service';
import {
    UserEditResolver,
    UserRoleResolver
} from './../users/services/user.resolver.service';
import { UserService } from './../users/services/user.service';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSharedModule } from './../shared/appShared.module';
import { ContactComponent } from './contact.component';
import { ContactServices } from './services/contact.service';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import {
    ContactEditResolver,
    ContactTypeResolver,
    FunctionListResolver,
    CountryCodeListResolver,
    CustomerContactsWithLoginResolver,
    CustomerContactsWithResolver,
} from './services/contact.resolver.service';

import {
    CustomerContactLoginComponent,
    CustomerContactComponent,
    ContactListComponent,
    ContactEditComponent,
    ContactFormComponent
} from './components/index';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@NgModule({
    imports: [
        AppSharedModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        ConfirmDialogModule,
        KubaExportModule
    ],
    exports: [
        ContactComponent,
        CustomerContactLoginComponent,
        CustomerContactComponent,
        ContactListComponent,
        ContactEditComponent,
        ContactFormComponent,
    ],
    declarations: [
        ContactComponent,
        CustomerContactLoginComponent,
        CustomerContactComponent,
        ContactListComponent,
        ContactEditComponent,
        ContactFormComponent
    ],
    providers: [
        ContactServices,
        ContactEditResolver,
        ValidationService,
        ConfirmationService,
        UserService,
        UserEditResolver,
        ContactTypeResolver,
        FunctionListResolver,
        CountryCodeListResolver,
        CustomerContactsWithLoginResolver,
        CustomerContactsWithResolver,
        BusinessUserEditResolver,
        UserRoleResolver,
        CompanyNameFastResolver
    ]
})
export class ContactModule { }
